import UAParser from "ua-parser-js";

const getUserAgent = () => {
  if (typeof navigator !== "undefined") return navigator.userAgent;
  return "";
};

const getBrowserName = (browserName = "") => {
  if (browserName === "Chrome WebView" || browserName === "Chromium") {
    return "Chrome";
  }
  if (browserName === "Mobile Safari") return "Safari";
  if (browserName === "Firefox Focus") return "Firefox";
  return browserName || "Chrome";
};

const getIsMediaRecorderEnabled = () =>
  typeof window !== "undefined" &&
  Boolean(
    window.MediaRecorder &&
      window.MediaRecorder.isTypeSupported &&
      window.MediaRecorder.isTypeSupported("video/webm"),
  );

class UserAgentUtil {
  static getDeviceApi() {
    const userAgent = getUserAgent();
    const parser = new UAParser(userAgent);
    const browserName = getBrowserName(parser.getBrowser().name);
    const device = parser.getDevice();
    const os = parser.getOS();
    const isLikelyIPadOS =
      typeof navigator !== "undefined" &&
      navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 1;

    const isIOS =
      isLikelyIPadOS ||
      os.name === "iOS" ||
      /iPad|iPhone|iPod/.test(userAgent);
    const isTablet =
      isLikelyIPadOS ||
      device.type === "tablet" ||
      /iPad|Tablet/.test(userAgent);
    const isPhone =
      !isTablet &&
      (device.type === "mobile" || /iPhone|iPod|Mobi/.test(userAgent));
    const isMobile = isPhone || isTablet;
    const isDesktop = !isMobile;

    const deviceName = (() => {
      if (isIOS && isTablet) return "iPad";
      if (isIOS && isPhone) return "iPhone";
      if (device.model) return device.model;
      if (isPhone) return "Phone";
      if (isTablet) return "Tablet";
      return "Desktop";
    })();

    const deviceType = isTablet ? "tablet" : isPhone ? "phone" : "desktop";

    return {
      deviceType,
      deviceName,
      browserName,
      isMobile,
      isPhone,
      isTablet,
      isChrome: browserName === "Chrome",
      isSafari: browserName === "Safari",
      isFirefox: browserName === "Firefox",
      isIOS,
      isDesktop,
      isMediaRecorderEnabled: getIsMediaRecorderEnabled(),
    };
  }
}

export default UserAgentUtil;
